import React, { useContext } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { 
  FaUserCircle, FaTachometerAlt, FaCalendarCheck, 
  FaBookOpen, FaChartBar, FaSignOutAlt
} from 'react-icons/fa';
import bliveLogo from '../assets/blive-logo.png';

const AdminLayout = () => {
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="d-flex vh-100 bg-light">
      {/* Sidebar */}
      <div className="bg-primary-custom text-white d-flex flex-column shadow" style={{ width: '260px' }}>
        <div className="p-4 border-bottom border-secondary d-flex flex-column align-items-center justify-content-center gap-3">
          <img src={bliveLogo} alt="b:live Logo" style={{ width: '130px', height: 'auto', objectFit: 'contain' }} />
          <h6 className="m-0 fw-bold text-uppercase tracking-wide opacity-75">Campus Portal</h6>
        </div>
        
        <ul className="nav flex-column mt-3 flex-grow-1 px-2">
          <li className="nav-item mb-1">
            <NavLink to="/admin" end className={({ isActive }) => `nav-link text-white rounded p-3 d-flex align-items-center gap-3 ${isActive ? 'bg-secondary-custom' : 'opacity-75 hover-opacity-100'}`}>
              <FaTachometerAlt size={18} />
              <span>Dashboard</span>
            </NavLink>
          </li>
          <li className="nav-item mb-1">
            <NavLink to="/admin/drives" className={({ isActive }) => `nav-link text-white rounded p-3 d-flex align-items-center gap-3 ${isActive ? 'bg-secondary-custom' : 'opacity-75 hover-opacity-100'}`}>
              <FaCalendarCheck size={18} />
              <span>Drive Management</span>
            </NavLink>
          </li>
          <li className="nav-item mb-1">
            <NavLink to="/admin/question-bank" className={({ isActive }) => `nav-link text-white rounded p-3 d-flex align-items-center gap-3 ${isActive ? 'bg-secondary-custom' : 'opacity-75 hover-opacity-100'}`}>
              <FaBookOpen size={18} />
              <span>Question Bank</span>
            </NavLink>
          </li>
          <li className="nav-item mb-1">
            <NavLink to="/admin/results" className={({ isActive }) => `nav-link text-white rounded p-3 d-flex align-items-center gap-3 ${isActive ? 'bg-secondary-custom' : 'opacity-75 hover-opacity-100'}`}>
              <FaChartBar size={18} />
              <span>Results & Analytics</span>
            </NavLink>
          </li>
        </ul>

        <div className="p-3 border-top border-secondary">
          <div className="d-flex align-items-center gap-3 mb-3 px-2">
            <FaUserCircle size={32} />
            <div>
              <p className="m-0 fw-bold">{user?.name || 'Admin User'}</p>
              <small className="opacity-50">Administrator</small>
            </div>
          </div>
          <button onClick={handleLogout} className="btn btn-outline-light w-100 d-flex align-items-center justify-content-center gap-2">
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </div>
      
      {/* Main Content Area */}
      <div className="flex-grow-1 d-flex flex-column overflow-hidden">
        {/* Top Navbar */}
        <header className="bg-white p-3 shadow-sm d-flex justify-content-end align-items-center z-1">
          <div className="d-flex align-items-center gap-3">
            <button className="btn position-relative p-2">
              <i className="bi bi-bell fs-5"></i>
              <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"></span>
            </button>
            <div className="bg-primary-custom text-white rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{ width: '40px', height: '40px' }}>
              {user?.name ? user.name.charAt(0) : 'A'}
            </div>
          </div>
        </header>
        
        {/* Page Content */}
        <main className="flex-grow-1 p-4 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
